<template>
    <vProductComponent :postList="postList" v-if="flag"></vProductComponent>
</template>
<script>
import vProductComponent from '../../listComponent/basicdata/product/productComponent.vue';
export default {
    name: 'product',
    components: {
        vProductComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                name: true,
                rid: true,
                product_licence_number: true,
                product_common_name: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>